<template>
    <div>
        <div class="cf ph2 pb1">
            <div class="formLabel fl">{{ label }}</div>
            <span class="fr"><slot></slot></span>
        </div>
        <Slider :min="min" :max="max" :interval="interval" :value="value" @input="update" @drag-end="dragEnd"/>
    </div>
</template>

<script>
import Slider from '@/components/controls/Slider.vue';

export default {
    components: {
        Slider
    },
    props: {
        label: {
            type: String
        },
        min: {
            type: Number,
            required: true
        },
        max: {
            type: Number,
            required: true
        },
        interval: {
            type: Number,
            default: 1
        },
        value: {
            type: Number,
            required: true
        }
    },
    methods: {
        update(value) {
            this.$emit('input', value);
        },
        dragEnd(value) {
            this.$emit('drag-end', value);
        }
    }
};
</script>
